



















import {Component} from "vue-property-decorator"
import BaseVue from "@/utils/BaseVue"
import router from "@/router"

@Component
export default class Navbar extends BaseVue {

    get isAuthenticated(): boolean {
        return this.$typedStore.getters.auth.isAuthenticated()
    }

    get username(): string {
        return this.$typedStore.state.auth.user.preferred_username
    }

    private async onLogoutButtonClicked() {
        await this.$typedStore.actions.auth.signOut()
        router.replace("/login")
    }
}
